import styled from 'styled-components';

export const Location = styled.p`
  font-weight: bold;
  font-size: 0.9em;
  text-transform: capitalize;
  margin-bottom: 5px;
`;
